import { Button, ButtonProps, makeStyles } from "@material-ui/core";
import * as React from "react";

import { buttonBaseStyle, buttonSizeStyles } from "@/buttonStyles";
import { semanticColors as colors } from "@/designTokens";

const useStyles = makeStyles({
  button: {
    "&&&": {
      ...buttonBaseStyle,
      ...buttonSizeStyles.L,
      backgroundColor: colors["surface/card"],
      backgroundImage: "none",
      border: `1px solid ${colors["border/strong"]}`,
      color: colors["text/primary"],
      "&:hover, &:active": {
        backgroundColor: colors["surface/base"],
        backgroundImage: "none",
        borderColor: colors["border/strong"],
        color: colors["text/primary"],
        boxShadow: "none",
      },
      "&.Mui-disabled": {
        backgroundColor: colors["surface/card"],
        backgroundImage: "none",
        borderColor: colors["border/strong"],
        color: colors["text/disabled"],
      },
    },
    "& .MuiButton-label": { display: "inline-flex", alignItems: "center", gap: 8 },
  },
  icon: { width: 18, height: 18, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" },
});

/** ソーシャル認証は通常の青いOutlineと別の共通スタイル。 */
export const SocialLoginButton: React.FC<ButtonProps & { provider: "google" | "apple"; labelSize?: number }> = ({
  provider,
  labelSize,
  ...props
}) => {
  const classes = useStyles();
  return (
    <Button
      {...props}
      type="button"
      fullWidth
      className={classes.button}
      style={labelSize ? { fontSize: labelSize } : undefined}
    >
      <span className={classes.icon} aria-hidden="true">
        <img src={`/icons/ds-v2-${provider}.svg`} alt="" />
      </span>
      {provider === "google" ? "Googleでログイン" : "Appleでサインイン"}
    </Button>
  );
};
